import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';

/* global customElements */
class BillingPreferences extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var billingPreferences = this;
		setTimeout(function(){
			billingPreferences.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var billingPreferences = this;
		
		var tabPanel = ElementUtil.create({
			tag: 'dl-tabpanel',
			slot: 'primary',
			listeners: {
				ready: function(e) {									
					tabPanel.addTabs([
						{
							'tab-title': 'Pay Method',
							tag: 'div',
							style: 'height: 100%;',
							children: [	
								{
									tag: 'dl-form-panel',
									itemid: 'paymethod-form',
									children: [
										{
											tag: 'vaadin-form-layout',										
											children: [	
												{
													tag: 'vaadin-combo-box',		
													itemId: 'paymentType',
													label: 'Active Payment Method', 
													name: 'paymentType',
													required: true,
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('PaymentType').then(function(data){
															combo.items = data;
														});
													},
													listeners: {
														change: function() {
															var selection = ElementUtil.query(tabPanel, 'paymentType').value;															
															if (selection === 'TCH') {
																ElementUtil.query(tabPanel, 'accountName').classList.remove('hide');
																ElementUtil.query(tabPanel, 'contractId').classList.remove('hide');
																ElementUtil.query(tabPanel, 'carrierId').classList.remove('hide');
																ElementUtil.query(tabPanel, 'autoBillFlag').classList.remove('hide');
															} else {
																ElementUtil.query(tabPanel, 'accountName').classList.add('hide');
																ElementUtil.query(tabPanel, 'contractId').classList.add('hide');
																ElementUtil.query(tabPanel, 'carrierId').classList.add('hide');
																ElementUtil.query(tabPanel, 'autoBillFlag').classList.add('hide');
															}
														}
													}
												},
												{
													tag: 'vaadin-text-field',
													itemid: 'accountName',												
													label: 'Account Name',
													name: 'accountName',																								
													maxlength: 255
												},
												{
													tag: 'vaadin-number-field',
													itemid: 'contractId',													
													label: 'Contract Id *',													
													name: 'contractNo'
												},
												{
													tag: 'vaadin-number-field',
													itemid: 'carrierId',													
													label: 'Carrier Id *',
													name: 'carrierId'
												},
												{
													tag: 'vaadin-checkbox',									
													itemid: 'autoBillFlag',	
													name: 'autoBillFlag',
													label: 'Auto Bill Account'
												},
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:database', ' Save')
															],
															listeners: {
																click: function() {															
																	
																	var form = ElementUtil.query(tabPanel, 'paymethod-form');	
																	var values = form.getData();
																	var valid = true;
																	if (values.paymentType === 'TCH') {
																		if (!values.contractNo || !values.carrierId) {
																			valid = false;
																			ElementUtil.query(tabPanel, 'contractNo').errorMessage = 'Contract Id is required';
																			ElementUtil.query(tabPanel, 'contractNo').invalid = true;
																			ElementUtil.query(tabPanel, 'carrierId').errorMessage = 'Carrier Id is required';
																			ElementUtil.query(tabPanel, 'carrierId').invalid = true;																			
																		}
																	}
																	
																	if (valid) {
																		form.submitForm({
																			preSubmit: function(data) {	

																				if (values.paymentType === 'TCH') {
																					data.tchAccount = {
																						accountName: data.accountName,
																						contractNo: data.contractNo,
																						tchCarrierId: data.carrierId,
																						autoBillFlag: data.autoBillFlag
																					};
																				}

																				return data;
																			},
																			actualCall: function(data) {																														
																				return BillingService.getAccountService().updateCurrentPaymethod(billingPreferences.detail.companyId, data);
																			},
																			success: function(data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved ', {
																					theme: 'success',
																					position: 'top-stretch'
																				});																																				
																			}
																		});	
																	}
																}
															}
														}
													]
												}
											]
										}
									],
									postinit: function(form) {
										
										BillingService.getAccountService().getAccountCurrentPaymethod(billingPreferences.detail.companyId).then(function(paymentMethod){
											
											var loadRecord = {
												paymentType: paymentMethod.paymentType
											};
											if (paymentMethod.tchAccount) {
												loadRecord.accountName = paymentMethod.tchAccount.accountName;
												loadRecord.contractNo = paymentMethod.tchAccount.contractNo;
												loadRecord.carrierId = paymentMethod.tchAccount.tchCarrierId;
												loadRecord.autoBillFlag = paymentMethod.tchAccount.autoBillFlag;
											}
									
											form.load(loadRecord);
											
											var event = new Event('change');
											ElementUtil.query(tabPanel, 'paymentType').dispatchEvent(event);
											
											
										});	
									}
								}
							]
						},
						{
							'tab-title': 'Billing Options',
							tag: 'div',
							style: 'height: 100%;',
							children: [	
								{
									tag: 'dl-form-panel',
									itemid: 'billing-options-form',
									children: [
										{
											tag: 'vaadin-form-layout',										
											children: [	
												{
													tag: 'vaadin-date-picker',
													label: 'Billing Start Date',												
													name: 'billingStartDate'							
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Cycle Day', 
													name: 'billingCycleDay',
													'item-value-path': 'code',
													'item-label-path': 'description',																										
													postinit: function(combo) {
														var data = [];
														for (var i=1; i<29; i++) {
															data.push({
																code: i,
																description: i
															});
														}
														combo.items = data;
														combo.required = true;
													}																									
												},
												{
													tag: 'vaadin-combo-box',											
													label: 'Payment Option', 
													name: 'paymentOption',													
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('PaymentOption').then(function(data){
															combo.items = data;
															combo.required = true;
														});
													}
												},
												{													
													tag: 'vaadin-checkbox',									
													name: 'billingBehindFlag',
													label: 'Bill Behind'													
												},
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:database', ' Save')
															],
															listeners: {
																click: function() {															
																	var form = ElementUtil.query(tabPanel, 'billing-options-form');																	
																	form.submitForm({
																		preSubmit: function(data) {	
																			if (data.billingStartDate) {
																				data.billingStartDate = TimeUtil.normalizeBillingCalendarDateForSubmit(data.billingStartDate);
																			}
																			return data;
																		},
																		actualCall: function(data) {																														
																			return BillingService.getAccountService().updateBillingOptions(billingPreferences.detail.companyId, data);
																		},
																		success: function(data, responseData) {
																			window.DL.MessageUtil.showToast('Success', 'Saved ', {
																				theme: 'success',
																				position: 'top-stretch'
																			});																																				
																		}
																	});														
																}
															}
														}
													]
												}
											]
										}
									],
									postinit: function(form) {										
										form.load(billingPreferences.detail.account);										
									}
								}			
							]									
						},
						{
							'tab-title': 'Account Options',
							tag: 'div',
							style: 'height: 100%;',
							children: [	
								{
									tag: 'dl-form-panel',
									itemid: 'account-options-form',
									children: [
										{
											tag: 'vaadin-form-layout',										
											children: [	
												{
													tag: 'vaadin-combo-box',														
													label: 'Payment Terms', 
													name: 'ourPaymentTerms',													
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('OurPaymentTerms').then(function(data){
															combo.items = data;
															combo.required = true;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',														
													label: 'Notification Type', 
													name: 'notificationSendMethod',													
													'item-value-path': 'code',
													'item-label-path': 'description',
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('MessageSendMethod').then(function(data){
															combo.items = data;
															combo.required = true;
														});
													}													
												},
												{
													tag: 'vaadin-text-field',
													label: 'First name',
													name: 'billingFirstName',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-text-field',
													label: 'Last Name',
													name: 'billingLastName',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-text-field',
													label: 'Phone',
													name: 'billingPhone',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-email-field',
													label: 'Email',
													name: 'billingEmail',
													required: true,
													maxLength: 200
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Inside Sales', 
													name: 'insideSalesRep',
													'item-value-path': 'salesRepId',
													'item-label-path': 'description',																									
													postinit: function(combo) {
														BillingService.getSalesRepService().getSaleReps().then(function(salesRep){
															salesRep.data.forEach(function(rep){
																rep.description = rep.repFirstName + ', ' + rep.repLastName; 
															});
															combo.items = salesRep.data;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Outside Sales', 
													name: 'outsideSalesRep',
													'item-value-path': 'salesRepId',
													'item-label-path': 'description',																									
													postinit: function(combo) {
														BillingService.getSalesRepService().getSaleReps().then(function(salesRep){
															salesRep.data.forEach(function(rep){
																rep.description = rep.repFirstName + ', ' + rep.repLastName; 
															});
															combo.items = salesRep.data;
														});
													}
												},
												{													
													tag: 'vaadin-checkbox',									
													name: 'doNotBillFlag',
													label: 'Do Not Bill'													
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendBillingNoticeFlag',												
													colspan: 2,
													label: 'Billing Notices'	
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendInvoiceFlag',													
													colspan: 2,
													label: 'Send Invoice Email'	
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendPaymentFlag',
													colspan: 2,
													label: 'Sending Payment Email'	
												},	
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:database', ' Save')
															],
															listeners: {
																click: function() {															
																		
																	var form = ElementUtil.query(tabPanel, 'account-options-form');																	
																	form.submitForm({
																		preSubmit: function(data) {	
																			return data;
																		},
																		actualCall: function(data) {																														
																			return BillingService.getAccountService().updateAccountOptions(billingPreferences.detail.companyId, data);
																		},
																		success: function(data, responseData) {
																			window.DL.MessageUtil.showToast('Success', 'Saved Account Options', {
																				theme: 'success',
																				position: 'top-stretch'
																			});																																				
																		}
																	});
																	
																}
															}
														}
													]
												}
											]
										}
									],
									postinit: function(form) {																				
										form.load(billingPreferences.detail.account);										
									}
								}								
							]									
						}
					]);
				}
			}
		});
			
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [			
				tabPanel
			]
		});		
		billingPreferences.append(flexLayout);
		
	}
	
};
customElements.define('dl-account-billing-preferences', BillingPreferences);	


